module.exports = __webpack_public_path__ + "img/5_1_m.d6f3e0d9.jpg";